import { Col, Input, Row, Card, Rate, Typography, Button, Spin } from "antd";
import React, { FC, useState } from "react";
import styled from "styled-components";
import { ExpertText, SmallText } from "../../../Components/Text3D";
import SearchIcon from "../../../assets/images/searchIcon.png";
import { useQuery } from "@apollo/client";
import { GET_ALL_PRINTERS } from "../../../Apollo/graphql/Query";
import { getUserData } from "../../../utils/utilsFunctions";






const { Search } = Input;

const MainWrapper = styled(Row)`

/* &:before{
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 35rem;

      @media screen and (max-width: 900px) {
          display: none;
      }
    } */
`;
const ContentWrapper = styled(Col)`
  background-color: white;
  padding-bottom: 2rem;
  width: 100%;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`
const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0 0.6rem 0.5rem;
  margin: 0 2rem;
  border-bottom: 1px solid #d8d8d8;
`;
const SearchBarContainer = styled(Row)`
  display: flex;
  margin-top: 2rem;
  padding-left: 3rem;
  padding-right: 4rem;
  height: 3rem;
`;
const SearchX = styled(Search)`
  .ant-btn{
     background-color: rgba(9, 185, 79, 1);
     border: none;
 }
`
const Section = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 0.5rem;
`;
const CardX = styled(Card)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  .ant-card-body{
    padding: 16px;
  }
  .ant-card-cover{
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
  }
`
const Img = styled.img`
    display: inline-block;
    width: inherit;
    max-width: 100%;
`;
const RatingSection = styled.div`
  border-top: 1px solid #D8D8D8;
  padding:.2rem 0;
  display: flex;
  flex-direction: column;
`
const ImageBottomSection = styled.div`
  /* margin-top: 2rem; */
  margin-bottom: .5rem;
`

const SpanX = styled(Typography)`
  font-size: 16px;
`
const Strong = styled.strong`
  font-size: 16px;
`


interface Props {
  handleClick(data: any): any;
}
const UploadNewDesignSelectPage: FC<Props> = ({ handleClick }) => {
  const [printers, setPrinters] = useState([]);
  const user = JSON.parse(getUserData('user'))

  const { loading } = useQuery(GET_ALL_PRINTERS, {
    variables: {
      PaginationInput: {
        page: 1,
        limit: 100
      },
    }, onCompleted: data => {
      setPrinters(data.printers.printers)
    }, onError: (err) => {
      console.log("data couldn't fetch")
    }
  });
  const handleSelectClick = (printer: any) => {

    let printerId = printer._id;
    let printerName = printer.name;
    let sellerName = printer.owner.firstName;
    let price = printer.price;
    let length = printer.length;
    let width = printer.width;
    let printerOwnerId = printer.owner._id;
    let height = printer.height;
    let finalData = { printerId, printerOwnerId, printerName, price, sellerName, length, width, height }
    handleClick(finalData);
  }

  return (
    <Spin spinning={loading}>
      <MainWrapper>
        <ContentWrapper>
          <TopSection>
            <ExpertText dark>
              Dashboard / <a href="s">Upload New Design</a>
            </ExpertText>
          </TopSection>
          <SearchBarContainer>
            <Col span={5}>
              <Section>
                <SmallText bold>Select Printer</SmallText>
              </Section>
            </Col>
            <Col span={13} style={{ marginLeft: "-2rem" }}>
              <Search
                prefix={
                  <img src={SearchIcon} alt="" style={{ paddingRight: "1rem" }} />
                }
                placeholder="input search text"
                enterButton="SEARCH"
                size="large"
              />
            </Col>
            <Col span={6} style={{ marginLeft: "1.5rem" }}>
              <SearchX
                placeholder="input search text"
                enterButton="Go"
                size="large"
              />
            </Col>
          </SearchBarContainer>
          <div style={{ margin: '2rem 4.5rem' }}>
            <Row gutter={[32, 32]} style={{ width: '100%' }}>
              {
                printers && printers.map((printer: any) => {
                  return (
                    <Col span={8} key={printer._id}>
                      <CardX
                        cover={<Img src={printer.featuredImage} alt=""></Img>}
                      >
                        <ImageBottomSection>
                          <SpanX>
                            <strong>{printer.name}</strong>
                          </SpanX>
                          <SpanX>Brand: {printer.brand}</SpanX>
                        </ImageBottomSection>
                        <RatingSection>
                          <span>
                            <Strong>Rating:</Strong>
                            <Rate
                              defaultValue={3}
                              style={{ paddingLeft: "1rem" }}
                              disabled
                            ></Rate>
                          </span>
                          <span style={{ margin: ".5rem 0" }}>
                            <Strong>Price:</Strong>
                            <span style={{ paddingLeft: "1rem" }}>
                              {printer.price}
                            </span>
                          </span>
                        </RatingSection>
                        <Button
                          type="primary"
                          style={{
                            margin: "1rem 0",
                            width: "100%",
                            height: "48px",
                            fontSize: "20px",
                          }}
                          onClick={() => {
                            handleSelectClick(printer);
                          }}
                          disabled={user.paymentSetupComplete === false}
                        >
                          SELECT THIS PRINTER
                        </Button>
                      </CardX>
                    </Col>
                  );
                })
              }
            </Row>
          </div>
        </ContentWrapper>
      </MainWrapper>
    </Spin>
  );
};

export default UploadNewDesignSelectPage;
